'use client';
import type { Assign } from '@ark-ui/react';
import { Popover } from '@ark-ui/react';
import { type PopoverVariantProps, popover } from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withRootProvider, withContext } = createStyleContext(popover);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withRootProvider<
  Assign<Popover.RootProviderProps, PopoverVariantProps>
>(Popover.RootProvider);

export type RootProps = ComponentProps<typeof Root>;
export const Root = withRootProvider<
  Assign<Popover.RootProps, PopoverVariantProps>
>(Popover.Root);

export const Anchor = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Popover.AnchorProps>
>(Popover.Anchor, 'anchor');

export const Arrow = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Popover.ArrowProps>
>(Popover.Arrow, 'arrow');

export const ArrowTip = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Popover.ArrowTipProps>
>(Popover.ArrowTip, 'arrowTip');

export const CloseTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, Popover.CloseTriggerProps>
>(Popover.CloseTrigger, 'closeTrigger');

export const Content = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Popover.ContentProps>
>(Popover.Content, 'content');

export const Description = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Popover.DescriptionProps>
>(Popover.Description, 'description');

export const Indicator = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Popover.IndicatorProps>
>(Popover.Indicator, 'indicator');

export const Positioner = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Popover.PositionerProps>
>(Popover.Positioner, 'positioner');

export const Title = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Popover.TitleProps>
>(Popover.Title, 'title');

export const Trigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, Popover.TriggerProps>
>(Popover.Trigger, 'trigger');

export { PopoverContext as Context } from '@ark-ui/react';
